import React from "react";
import { BaseModal } from "./BaseModal";
import { useStore } from "../../stores/store";
import { ModalKeys } from "../../interfaces/config";

export default function MaxPrintRecordExceededModal() {
  const { isActive, deactivateTool } = useStore();
  return (
    <BaseModal
      active={isActive(ModalKeys.MAX_PRINT_RESULTS_EXCEEDED)}
      title="MAX PRINT RECORDS EXCEEDED"
    >
      <div className="p-3 font-helvetica text-sm">
        <p>Attention:</p>
        <p>
          You have attempted to print more parcels than the allowed limit of
          100. The first 100 will be included in your printout. You can print as
          many "summary" parcels as needed.
        </p>
      </div>
      <div className="bg-[#f5f5f5] border-t border-[#ddd] w-full text-right p-1">
        <button
          onClick={() => deactivateTool(ModalKeys.MAX_PRINT_RESULTS_EXCEEDED)}
          className="btn-athena btn-sm mr-1"
        >
          Ok
        </button>
      </div>
    </BaseModal>
  );
}
